/**
 * Reader-facing names that do not localize: platform product names, and the
 * status a band maps to on the report tokens (good, warn, poor).
 */

import type { ScoreBand, SitePlatform } from './types';

export const PLATFORM_NAMES: Record<Exclude<SitePlatform, 'unknown' | 'static-other'>, string> = {
  shopify: 'Shopify',
  woocommerce: 'WooCommerce',
  wordpress: 'WordPress',
  wix: 'Wix',
  squarespace: 'Squarespace',
  webflow: 'Webflow',
  drupal: 'Drupal',
  nextjs: 'Next.js',
  'react-spa': 'React application',
  astro: 'Astro',
  bigcommerce: 'BigCommerce',
  magento: 'Magento',
};

export function platformName(platform: SitePlatform): string | null {
  return platform in PLATFORM_NAMES ? PLATFORM_NAMES[platform as keyof typeof PLATFORM_NAMES] : null;
}

/** The status token a band renders with: two bands share "good" so the meter reads in three colours. */
export function bandStatus(band: ScoreBand): 'good' | 'warn' | 'poor' {
  if (band === 'poor') return 'poor';
  if (band === 'needsWork') return 'warn';
  return 'good';
}
